import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import ReactDOM from 'react-dom'
import ApiService, {getCalcomBaseUrl} from '../ApiService'
import { Button, Col, Container, Form, Row, Spinner, Overlay, Tooltip, Dropdown, DropdownButton } from 'react-bootstrap'
import { clinicianIdFromRefreshAuth } from '../util/authUtil'
import {IoSearchOutline, IoRefreshOutline, IoPinOutline} from 'react-icons/io5'
import { AiOutlineEye } from 'react-icons/ai'
import {GrRefresh, GrStatusGoodSmall} from 'react-icons/gr'
import removeClass from '../util/RemoveCSS'
import PageTitle from './Common/PageTitle/PageTitle'
import 'react-datepicker/dist/react-datepicker.css'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
//import moment from 'moment'
import moment from 'moment-timezone'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { DateTime } from 'luxon'
import {capitalizeWords, getBackendFormatDate_yyyy_MM_dd, getBackendFormatDate_yyyy_MM_dd_Range, TIMEZONES, getBackendFormatDate_yyyy_MM_dd_Plus, getBackendFormatDate_yyyy_MM_dd_Minus} from '../util/common'
import GenericConfirmationModal from "./BookingDetails/Modals/GenericConfirmationModal";
import {TbCircleArrowUpRightFilled} from "react-icons/tb";
import {BsSquareFill, BsTagsFill} from "react-icons/bs";
import {BOOKING_STATUS_CONFIG, getStatusBgColor, getStatusFontColor} from "../util/bookingUtils";
import useLocalStorage from '../hooks/useLocalStorage'

let allViews = Object.keys(Views).map((k) => Views[k])

let tagsArray = ["Pending_Confirm", "Confirmed", "Done", "No-Show", "Paid", "Running_Late", "Rescheduled", "Need Reminder", "Reminder-Call-Done", "Reminder-SMS-Done", "Self-Checkin-Pending", "Self-Checkin-Complete", "Custom Label"];

let statusArray = ["Intent", "Pending Confirmation", "Active", "Unconfirmed", "Confirmed Upcoming", "Rescheduled", "Cancelled", "Completed"];

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const localizer = momentLocalizer(moment)
// const localizer = luxonLocalizer(DateTime);

const BookingSearchType = {
  DATE_RANGE: 'DATE_RANGE',
  LASTNAME_DOB: 'LASTNAME_DOB',
  BOOKING_ID: 'BOOKING_ID',
}

const FILTER_BOOKING_FOR = {
  ALL: 'ALL',
  SELF: 'SELF',
  UNASSIGNED: 'UNASSIGNED',
}

const CARE_LOCATIONS = {
  ALL: { value: 'ALL', display:  'All' },
  CHARLESTON_NV_89104: {value: 'CHARLESTON_NV_89104', display: 'Care Hub @ Las Vegas Charleston'},
  ONLINE: { value: 'ONLINE', display:'Online/Telemedicine' },
  DENVER_CAREHUB_01: { value: 'DENVER_CAREHUB_01', display: 'Care Hub @ 2101 Larimer St, Denver' },
}

const CARE_LOCATION_NAMES_ARR = Object.entries(CARE_LOCATIONS).map(([key, value]) => value.value);

const DEFAULT_PREFERRED_CAL_FILTER_ALL_VAL = 'All'
const UNKNOWN_CALENDER_NAME = 'Unknown'
const defaultCalenderNameSet = new Set()
defaultCalenderNameSet.add(DEFAULT_PREFERRED_CAL_FILTER_ALL_VAL)

const nowMinus45Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().minus({ days: 30 }))
const nowPlus45Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().plus({ days: 30 }))
const nowMinus7Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().minus({ days: 7 }))
const nowPlus7Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().plus({ days: 7 }))
const nowMinus2Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().minus({ days: 2 }))
const nowPlus2Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().plus({ days: 2 }))
const nowMinus1Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().minus({ days: 1 }))
const nowPlus1Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().plus({ days: 1 }))
const nowMinus31Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().minus({ days: 31 }))
const nowPlus31Days = getBackendFormatDate_yyyy_MM_dd(DateTime.now().plus({ days: 31 }))

const BookingCalendar = () => {
  const [allRawBookingData, setAllRawBookingData] = useLocalStorage("allRawBookingData", null)
  const [allCalData, setAllCalData] = useLocalStorage("allCalData", null)
  const [selfCalData, setSelfCalData] = useLocalStorage("selfCalData", null)
  const [unassignedCalData, setUnassignedCalData] = useLocalStorage("unassignedCalData", null)
  const [calData, setCalData] = useLocalStorage("calData", [])
  const [errors, setErrors] = useLocalStorage("errors", [])
  const [searchStatus, setSearchStatus] = useLocalStorage("searchStatus", "")
  const [showType, setShowType] = useLocalStorage("showType", null)
  const [loading, setLoading] = useState(true)
  const [isRemoteCallInProgress, setRemoteCallInProgress] = useState(true)
  const navigate = useHistory()
  const [preferredTimeZone, setPreferredTimeZone] = useLocalStorage('preferredTimeZone', null)
  const [clinicianId, setClinicianId] = useLocalStorage('clinicianId', null)
  const [currentView, setCurrentView] = useLocalStorage('currentView', Views.DAY)
  const [date, setDate] = useLocalStorage('date', new Date())
  const [dateRangeSelected, setDateRangeSelected] = useLocalStorage("dateRangeSelected",{
    start: nowMinus1Days,
    end: nowPlus1Days,
  })
  
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState('')
  const [snackSeverity, setSnackSeverity] = useState('')
  const systemDefaultTimezone = DateTime.local().zoneName
  const [calenderNameSet, setCalenderNameSet] = useLocalStorage("calenderNameSet", defaultCalenderNameSet)
  const [preferredCalName, setPreferredCalName] = useLocalStorage("preferredCalName", DEFAULT_PREFERRED_CAL_FILTER_ALL_VAL)
  const [filterCareLocation, setFilterCareLocation] = useLocalStorage("filterCareLocation", CARE_LOCATIONS.ALL.value)
  const [careLocationSet, setCareLocationSet] = useLocalStorage("careLocationSet", new Set());

  //` When Range changes, update dateRangeSelected 
  const onRangeChange = useCallback((range) => {
    if (Array.isArray(range)) {
      if (range.length === 1) {
        console.log('day', range)
        setDateRangeSelected({
          start: getBackendFormatDate_yyyy_MM_dd_Minus(range[0], 1),
          end: getBackendFormatDate_yyyy_MM_dd_Plus(range[0], 1),
        })
      } else if (range.length > 1) {
        console.log('week', range)
        setDateRangeSelected({
          start: getBackendFormatDate_yyyy_MM_dd_Minus(range[0], 1),
          end: getBackendFormatDate_yyyy_MM_dd_Plus(range[range.length - 1], 1),
        })
      }
    } else {
      console.log('month', range)
      setDateRangeSelected({
        start: getBackendFormatDate_yyyy_MM_dd_Range(range.start),
        end: getBackendFormatDate_yyyy_MM_dd_Range(range.end),
      })
    }
  }, [])

  //` When View changes, update currentView
  const onView = useCallback((view) => {
    setCurrentView(view);
  }, []);
  
  //` When back or Next is clicked, update date
  const onNavigate = useCallback((newDate, view) => {
    console.log('onNavigate', newDate, view)
    setCurrentView(view);
    setDate(newDate)
  }, [setCurrentView, setDate]);
  // console.log('dateRangeSelected', dateRangeSelected)

  const customDayLayoutAlgorithm = date => {
    const hour = moment(date).hour();
    if (hour === 10 && date.getMinutes() >= 30) {
      return [date, moment(date).add(60, 'minutes').toDate()]; // Increase the height between 10:30 AM and 11:00 AM
    } else {
      return [date, moment(date).add(30, 'minutes').toDate()]; // Default 30-minute time slots
    }
  };

  useEffect(() => {
    setLoading(true);
    clinicianIdFromRefreshAuth().then(id => setClinicianId(id));
  }, []);

  useEffect(() => {
    if (allRawBookingData === null) return
    setLoading(true)
    refreshLocalCalData();
    const eventTitles = allRawBookingData?.map(bd => bd?.eventTitle ?? 'None') ?? []
    setCalenderNameSet(eventTitles)
  }, [allRawBookingData]);

  useEffect(() => {
    if (calData === null) {
      setLoading(false)
      return
    }
    const calNameSet = new Set()
    calNameSet.add(DEFAULT_PREFERRED_CAL_FILTER_ALL_VAL)
    calData?.forEach(cd => calNameSet.add(cd?.calenderName || UNKNOWN_CALENDER_NAME))
    setCalenderNameSet(calNameSet.size === 0 ? defaultCalenderNameSet : calNameSet)
    setLoading(false)
  }, [calData])

  const handleSelectEvent = event => {
    handleSnackOpen(`loading booking detail...`, 'success')
    setLoading(true)
    try {
    } catch (err) {
      handleSnackOpen(`failed loading booking detail...`, 'error')
    } finally {
      setLoading(false)
    }
    let path = `BookingDetails`
    navigate.push({
      pathname: path,
      search: '?bookingId=' + event.bookingId,
    })
  }

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity)
    setSnackText(text)
    setSnackOpen(true)
  }

  const handleSnackClose = () => {
    setSnackOpen(false)
  }

  const dateTimeInPreferredZone = dateTimeStr => {
    const isoStr = preferredTimeZone
      ? DateTime.fromISO(dateTimeStr)
          .setZone(preferredTimeZone)
          .toISO({ includeOffset: false })
      : DateTime.fromISO(dateTimeStr).toISO();
    // return new Date(isoStr);
    return moment(isoStr).toDate()
  }

  const parseBookingDataToCalEvents = (rawBookingData, isSelfOnly) => {
    if (!rawBookingData || rawBookingData?.length === 0) return []
    const calEventData = rawBookingData
      ?.filter(item => item?.appntStart)
      .filter(item => !isSelfOnly || item?.isAssignedToMe === true)
      .map((item, index) => {
        const {
          careType = {},
          careLocation = {},
          firstName = 'unknown',
          lastName = 'unknown',
          email = 'unknown',
          dob = 'unknown',
          mobile = 'unknown',
          state = 'unknown',
        } = item || {}

        const line1 = `\nCare selection: ${careType?.displayName ?? 'unknown'}, ${careLocation?.address ?? 'unknown'}\n\n`
        const line2 = `Name: ${firstName} ${lastName}, DOB/state: ${dob}, ${state}\n\n`
        const line3 = `Contact: ${email} ${mobile}\n`;
        const appntEnd = item?.appntEnd?.length > 0
        ? dateTimeInPreferredZone(item.appntEnd)
        : new Date(dateTimeInPreferredZone(item.appntStart).getTime() + 30 * 60 * 1000); // default to start + 30 mins if no end time

        let productNames = "unknown";
        if (item?.products?.length > 0) {
          item?.products.map((product, index) => {
            if (index == 0) {
              productNames = product?.name;
            } else {
              productNames += ", " + product?.name;
            }
          });
        }
        
        return {
          id: index,
          calenderName: item?.eventTitle ?? UNKNOWN_CALENDER_NAME,
          longTitle: `${line1} ${line2} ${line3}`,
          title: '',
          start: dateTimeInPreferredZone(item.appntStart),
          end: appntEnd,
          allDay: false,
          careLocationName: item.careLocation?.name ?? 'unknown',
          careLocation: `${item?.careType?.displayName ?? 'unknown'}, ${careLocation?.address ?? 'unknown'}`,
          patientName: `Name:${item?.firstName} ${item?.lastName}`,
          productType: item?.products?.[0]?.name ?? item?.careType?.displayName ?? 'unknown',
          productNames: productNames,
          rawName: `${item?.firstName} ${item?.lastName}`,
          patientContact: `Email:${item?.email} Phone: ${item?.mobile}`,
          rawEmail: item?.email,
          rawPhone: item?.mobile,
          rawDob: item?.dob,
          patientDemo: `DOB: ${item?.dob}, State: ${item?.state}`,
          bookingId: item.id,
          primaryClinicianId: item?.primaryClinicianId ?? 'none',
          isUnAssigned: item?.isUnAssigned ?? false,
          bookingStatus: item?.bookingStatus ?? 'UNKNOWN',
          tagOrLabel: item?.tagOrLabel ?? 'unknown',
          pronoun: item?.pronoun ?? 'unknown',
        }
      })
    return calEventData
  }

  useEffect(() => {
    if (searchStatus && allCalData) {
      let tmpRawData = allCalData
      const filteredCalData = tmpRawData?.filter(b => b.bookingStatus === searchStatus)
      setCalData(filteredCalData)
    }
  }, [searchStatus, allCalData])

  const fetchAndSetRawBookingData = useCallback(async () => {
    try {
      setRemoteCallInProgress(true);
      if (dateRangeSelected) {
        console.log('fetchAndSetRawBookingData dateRangeSelected');
        console.log('fetchAndSetRawBookingData dateRangeSelected', dateRangeSelected);
        const response = await ApiService.getAllBookingsForDateRange(dateRangeSelected?.start, dateRangeSelected?.end);
        setAllRawBookingData(response?.data ?? []);
      }

      
      // if (currentView === 'week' || currentView === 'work_week') {
      //   console.log('fetchAndSetRawBookingData week');
      //   const response = await ApiService.getAllBookingsForDateRange(nowMinus7Days, nowPlus7Days);
      //   setAllRawBookingData(response?.data ?? []);
      // } else if (currentView === 'month') {
      //   console.log('fetchAndSetRawBookingData month');
      //   const response = await ApiService.getAllBookingsForDateRange(nowMinus31Days, nowPlus31Days);
      //   setAllRawBookingData(response?.data ?? []);
      // } else if (currentView === 'day') {
      //   console.log('fetchAndSetRawBookingData day');
      //   const response = await ApiService.getAllBookingsForDateRange(nowMinus2Days, nowPlus2Days);
      //   setAllRawBookingData(response?.data ?? []);
      // } else if (currentView === 'agenda') {
      //   console.log('fetchAndSetRawBookingData agenda');
      //   const response = await ApiService.getAllBookingsForDateRange(nowMinus45Days, nowPlus45Days);
      //   setAllRawBookingData(response?.data ?? []);
      // } else {
      //   const response = await ApiService.getAllBookingsForDateRange(nowMinus45Days, nowPlus45Days);
      //   setAllRawBookingData(response?.data ?? []);
      // }
    } catch (error) {
      // Handle errors here
      console.error(error);
    } finally {
      setRemoteCallInProgress(false);
      setLoading(false);
    }
  }, [dateRangeSelected]);

    // call getAllBookingList in useCallback hook
    useEffect(() => {
      setLoading(true);
      fetchAndSetRawBookingData()
    }, [fetchAndSetRawBookingData]);

  const parseAndSetAllCalData = () => {
    try {
      const allCalData = parseBookingDataToCalEvents(allRawBookingData, false)
      setAllCalData(allCalData ?? []);
    } catch (ex) {
      console.error(ex)
      handleSnackOpen(`Failed parsing booking data for calender`, 'error')
      setLoading(false)
    }
  }

  const parseAndSetSelfOnlyCalData = () => {
    try {
      const selfOnlyCalData = parseBookingDataToCalEvents(allRawBookingData, true)
      setSelfCalData(selfOnlyCalData ?? [])
      //
      // setLoading(true)
      // const getAllBookingListRes = await ApiService.getAllBookingsForDateRange(nowMinus45Days, nowPlus45Days);
      // const myNewBookings = getAllBookingListRes?.data?.filter(item => item?.appntStart && item?.isAssignedToMe === true)
      //   .map((item, index) => {
      //     return {
      //       id: index,
      //       title: item?.careType ?? 'Unknown Care Type',
      //       start: new Date(item.appntStart),
      //       end: new Date(item.appntStart),
      //       allDay: false,
      //       bookingId: item.id,
      //       primaryClinicianId: item?.primaryClinicianId,
      //     }
      //   })
      // setCalData(myNewBookings);
      // setLoading(false)
    } catch (ex) {
      handleSnackOpen(`Failed parsing booking data for calender`, 'error')
      setLoading(false)
    } finally {
    }
  }

  const parseAndSetUnassignedCalData = () => {
    try {
      const firstGetAllData = parseBookingDataToCalEvents(allRawBookingData, false)
      const nowFilterUnassigned = firstGetAllData?.filter(item => item.isUnAssigned === true)
      setUnassignedCalData(nowFilterUnassigned ?? [])
    } catch (ex) {
      handleSnackOpen(`Failed parsing booking data for calender`, 'error')
      setLoading(false)
    } finally {
    }
  }

  const refreshLocalCalData = () => {
    parseAndSetAllCalData()
    parseAndSetSelfOnlyCalData()
    parseAndSetUnassignedCalData()
  }

  removeClass()

  function renderErrors() {
    return errors?.map((k, i) => {
      return (
        <li style={{ color: 'red' }} key={k}>
          {k}
        </li>
      )
    })
  }

  //$ Change Timezone Function
  const handleChangeTimezoneSubmit = () => {
    setLoading(true)
    try {
      refreshLocalCalData()
      handleSnackOpen('Timezone changed successfully', 'success');
    } catch (error) {
      handleSnackOpen(`Failed to set & update appointment timezone, please try again`, 'error');
    }
  }

  const setCalDataForShowType = () => {
    const st = showType ?? FILTER_BOOKING_FOR.ALL
    if (st === FILTER_BOOKING_FOR.ALL) {
      setCalData(allCalData)
      handleSnackOpen('Showing all bookings', 'success')
    } else if (st === FILTER_BOOKING_FOR.SELF) {
      setCalData(selfCalData)
      handleSnackOpen('Showing only your bookings', 'success')
    } else {
      handleSnackOpen('unsupported filter value', 'error')
    }
    //setLoading(false);
  }

  const handleApplyFilters = () => {
    setLoading(true)
    const st = showType ?? FILTER_BOOKING_FOR.ALL
    //const prefCalName = preferredCalName ?? DEFAULT_PREFERRED_CAL_FILTER_ALL_VAL
    const prefCareLocation = filterCareLocation || CARE_LOCATIONS.ALL.value;
    let toApplyCalData
    if (st === FILTER_BOOKING_FOR.ALL) {
      toApplyCalData = allCalData ?? []
      setCalData(allCalData)
      handleSnackOpen('Showing all bookings', 'success')
    } else if (st === FILTER_BOOKING_FOR.SELF) {
      setCalData(selfCalData)
      toApplyCalData = selfCalData ?? []
      handleSnackOpen('Showing only your bookings', 'success')
    } else if (st === FILTER_BOOKING_FOR.UNASSIGNED) {
      toApplyCalData = unassignedCalData ?? []
      handleSnackOpen('Showing only unassigned bookings', 'success')
    } else {
      toApplyCalData = allCalData ?? []
      handleSnackOpen('unsupported filter value', 'error')
    }
    // const filteredCalData = toApplyCalData?.filter(
    //   cd => prefCareLocation.value === DEFAULT_PREFERRED_CAL_FILTER_ALL_VAL || !cd?.calenderName || cd?.calenderName === UNKNOWN_CALENDER_NAME || cd?.calenderName === prefCalName
    // )
    const filteredCalData = toApplyCalData?.filter(
        cd => prefCareLocation === CARE_LOCATIONS.ALL.value
            || !cd?.careLocationName // include null care location also
            || CARE_LOCATION_NAMES_ARR.findIndex(cl => cl === cd?.careLocationName) === -1 // include unknown care location also
            || cd?.careLocationName?.toUpperCase() === prefCareLocation?.toUpperCase() // include selected care location
    );
    setCalData(filteredCalData)
    //setLoading(false);
  }

  const handleResetFilters = () => {
    setLoading(true)
    setShowType(FILTER_BOOKING_FOR.ALL)
    setPreferredCalName(DEFAULT_PREFERRED_CAL_FILTER_ALL_VAL)
    setSearchStatus("")
    handleApplyFilters()
  }

  useEffect(() => {
    if (allCalData === null && selfCalData === null) return
    setLoading(true)
    handleApplyFilters()
  }, [allCalData, selfCalData, showType, preferredCalName, filterCareLocation]);

  //$ Change Show Type
  const handleAllOrSelfOnlyFilterApply = () => {
    setLoading(true)
    try {
      refreshLocalCalData()
    } catch (error) {
      handleSnackOpen('Filtering failed, please try again', 'error')
    } finally {
      //setLoading(false);
    }
  }

  const handleFilterByCalenderApply = () => {
    setLoading(true)
    try {
      refreshLocalCalData()
    } catch (error) {
      handleSnackOpen('Filtering failed, please try again', 'error')
    } finally {
      //setLoading(false);
    }
  }

  const handleRefreshCalender = () => {
    setLoading(true)
    ;(function() {
      fetchAndSetRawBookingData().then(r => r)
    })()
  }

  return (
    <Container fluid>
      <PageTitle titleName={'Booking Calendar'} />
      <hr />
      <div>
        {BOOKING_STATUS_CONFIG.filter(config => config.status !== 'UNKNOWN').map((config, index) => (
            <span key={config.status}>
        <BsSquareFill color={config.color} style={{ marginRight: '5px' }} />
              {capitalizeWords(config.status)}
              {index !== BOOKING_STATUS_CONFIG.length - 2 && (
                  <>
                    &nbsp;<IoPinOutline />&nbsp;
                  </>
              )}
    </span>
        ))}

      </div>
      <hr />
      <Row style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 'auto', justifyContent: 'space-between', padding: '15px' }} className="Search-wrap">
          <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Col xs="auto">
              <Form.Group as={Row} controlId="dobb">
                <Form.Label id="cardFormLabel" column sm={4}>
                  Calendar Zone
                </Form.Label>
                <Col sm={8}>
                  <Form.Select
                    sm={6}
                    id="timezoneSelect"
                    className="form-control"
                    size="lg"
                    value={`${preferredTimeZone ?? systemDefaultTimezone}`}
                    onChange={e => setPreferredTimeZone(e.target.value)}
                  >
                    <option value={systemDefaultTimezone}>{`My Location - ${systemDefaultTimezone}`}</option>
                    <option value={TIMEZONES.PACIFIC.isoStr}>{TIMEZONES.PACIFIC.display}</option>
                    <option value={TIMEZONES.MOUNTAIN.isoStr}>{TIMEZONES.MOUNTAIN.display}</option>
                    <option value={TIMEZONES.CENTRAL.isoStr}>{TIMEZONES.CENTRAL.display}</option>
                    <option value={TIMEZONES.EASTERN.isoStr}>{TIMEZONES.EASTERN.display}</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            <Col xs="auto">
              <Button type="submit" size="md" onClick={handleChangeTimezoneSubmit} title={'displays bookings in  selected timezone'}>
                <IoSearchOutline title={'displays bookings in selected timezone'} /> Update
              </Button>
            </Col>
          </Row>
          <Col xs="auto">
            <Button type="submit" size="md" onClick={handleRefreshCalender}>
              <IoRefreshOutline color="white" style={{ color: 'white' }} /> Refresh Calender
            </Button>
          </Col>
          {/* <Col xs="auto">
              <Form.Group as={Row} controlId="dobb">
              <Form.Label id="cardFormLabel" column sm={4}>
                  Status
                </Form.Label>
                <Col sm={8}>
                  <Form.Select sm={6} id="timezoneSelect" className="form-control" size="lg" value={searchStatus} onChange={e => setSearchStatus(e.target.value)}>
                  <option value="" default selected disabled>select</option>
                              <option value="INTENT">Intent</option>
                              <option value="ACTIVE">Active</option>
                              <option value="UNCONFIRMED">Unconfirmed</option>
                              <option value="CONFIRMED_UPCOMING">Confirmed Upcoming</option>
                              <option value="RESCHEDULED">Rescheduled</option>
                              <option value="CANCELLED">Cancelled</option>
                              <option value="COMPLETED">Completed</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col> */}
        </div>
      </Row>
      <Row style={{ display: 'flex', justifyContent: 'center' }} className="mt-2 mb-2">
        <div style={{ width: 'auto', justifyContent: 'space-between', padding: '15px' }} className="Search-wrap">
          <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

          <Col xs="auto">
              <Form.Group as={Row} controlId="dobb">
              <Form.Label id="cardFormLabel" column sm={4}>
                  Status
                </Form.Label>
                <Col sm={8}>
                  <Form.Select sm={6} id="timezoneSelect" className="form-control" size="lg" value={searchStatus}
                               onChange={e => setSearchStatus(e.target.value)}>
                    <option value="" default selected disabled>Select</option>
                    <option value="BOOKED_PENDING_CONFIRMATION">Booked Pending Confirm</option>
                    <option value="BOOKED_CONFIRMED">Booked Confirmed</option>
                    <option value="PT_RESCHEDULED_PENDING_CONFIRMATION">PT Rescheduled Pending Confirm</option>
                    <option value="PT_RESCHEDULED_CONFIRMED">PT Rescheduled Confirmed</option>
                    <option value="CL_RESCHEDULED_PENDING_CONFIRMATION">CL Rescheduled Pending Confirm</option>
                    <option value="CL_RESCHEDULED_CONFIRMED">CL Rescheduled Confirmed</option>
                    <option value="CANCELLED">Cancelled[Pro-Active]</option>
                    <option value="CANCELLED_NO_SHOW">Cancelled - No Show</option>
                    <option value="CLINICAL_SERVICE_COMPLETED">Clinician Service Completed</option>
                    <option value="COMPLETED">Completed</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>

            <Col xs="auto">
              <Form.Group as={Row}>
                <Form.Label id="cardFormLabel" column sm={4}>
                  Type
                </Form.Label>
                <Col sm={8}>
                  <Form.Select sm={6} id="timezoneSelect" className="form-control" size="lg" value={showType} onChange={e => setShowType(e.target.value)}>
                    <option value={FILTER_BOOKING_FOR.ALL}>Show All Bookings</option>
                    <option value={FILTER_BOOKING_FOR.SELF}>Show Only My Bookings</option>
                    <option value={FILTER_BOOKING_FOR.UNASSIGNED}>Show Unassigned Bookings</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>

            {/*<Col>*/}
            {/*  <Form.Group as={Row}>*/}
            {/*    <Form.Label id="cardFormLabel" column sm={4}>*/}
            {/*      Calendar Name*/}
            {/*    </Form.Label>*/}
            {/*    <Col sm={8}>*/}
            {/*      <Form.Select sm={6} id="calenderName" className="form-control" size="lg" value={preferredCalName}
            onChange={e => setPreferredCalName(e.target.value)}>*/}
            {/*        {[...calenderNameSet].map(cn => (*/}
            {/*          <option value={cn}>{cn}</option>*/}
            {/*        ))}*/}
            {/*      </Form.Select>*/}
            {/*    </Col>*/}
            {/*  </Form.Group>*/}
            {/*</Col>*/}

            <Col>
              <Form.Group as={Row}>
                <Form.Label id="cardFormLabel" column sm={4}>
                  Location
                </Form.Label>
                <Col sm={8}>
                  <Form.Select sm={8} id="calenderName" className="form-control" size="lg"
                               value={filterCareLocation}
                               onChange={e => setFilterCareLocation(e.target.value)}>
                    {Object.entries(CARE_LOCATIONS).map(([key, value]) => (
                        <option key={key} value={value.value}>{value.display}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>



            <Col xs="auto">
              <Button type="submit" size="md" onClick={handleApplyFilters}>
                <AiOutlineEye /> Filter Bookings
              </Button>
            </Col>

            <Col xs="auto">
              <Button type="submit" size="md" onClick={handleResetFilters}>
                <AiOutlineEye /> Reset filters
              </Button>
            </Col>
          </Row>
        </div>
      </Row>

      <Container fluid={'xxl'}>
        {loading || isRemoteCallInProgress ? (
          <Row>
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </Row>
        ) : (
          <>
            <Row>
              <Col>{renderErrors()}</Col>
            </Row>
            {calData && (
              <Row className="mt-2 Search-wrap" style={{ width: 'auto' }}>
                <Calendar
                    //onSelectEvent={handleSelectEvent}
                    date={date}
                  localizer={localizer}
                  events={calData}
                  startAccessor="start"
                  endAccessor="end"
                  style={{ width: '100%', height: 750 }}
                    views={allViews}
                    onRangeChange={onRangeChange}
                    dayLayoutAlgorithm={"no-overlap"}
                    onNavigate={onNavigate}
                    onView={onView}
                    defaultView={currentView}
                  components={{
                      event: Event,
                      day: {
                        event: Event,
                      },
                      week: {
                        event: Event,
                      },
                      agenda: {
                        event: Event,
                      },
                    }}
                    timeslots={1}
                  eventPropGetter={event => {
                    if (event?.primaryClinicianId === clinicianId) {
                      return {
                        style: {
                          width: '100%',
                          // height: '100%',
                          //backgroundColor: '#77DD77',
                          backgroundColor: getStatusBgColor(event?.bookingStatus),
                          borderRadius: '0px',
                          color: 'black',
                          border: '1px solid #2BAB2B',
                          display: 'block',
                        },
                      }
                    } else {
                      return {
                        style: {
                          width: '100%',
                          // height: '100%',
                          //backgroundColor: '#F8E0B2',
                          backgroundColor: getStatusBgColor(event?.bookingStatus),
                          borderRadius: '0px',
                          color: 'black',
                          border: '1px solid #F0BC59',
                          display: 'block',
                        },
                      }
                    }
                  }}
                />
              </Row>
            )}
          </>
        )}
      </Container>
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
    </Container>
  )
}

const TooltipContent = ({ onClose, event, handleSelectEvent }) => {
  const [selectedTag, setSelectedTag] = useState(null);
  const [customLabel, setCustomLabel] = useState("");
  const dropdownRef = useRef(null);
  const dropdownRef2 = useRef(null);
  const [isUpdateTagWip, setIsUpdateTagWip] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isShowBookingStatusUpdateModal, setIsShowBookingStatusUpdateModal] = useState(false);
  const [statusColor, setStatusColor] = useState("white");

  useEffect(() => {
    const key = event?.event?.bookingStatus && event?.event?.bookingStatus?.length > 0 ? event?.event?.bookingStatus : 'UNKNOWN';
    getStatusBgColor(key);
  },[]);

  const handleTagSelect = (tag) => {
    setSelectedTag(tag);
    if (tag === "Custom Label") {
      setCustomLabel("");
    }
  };

  const handleCustomLabelChange = (e) => {
    setCustomLabel(e.target.value);
  };

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState('')
  const [snackSeverity, setSnackSeverity] = useState('')

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity)
    setSnackText(text)
    setSnackOpen(true)
  }

  const handleSnackClose = () => {
    setSnackOpen(false)
  }

  const saveTag = async (selectedTagArg = null) => {
    const tagToUse = selectedTagArg ?? selectedTag;
    let label = null;
    if(tagToUse === "Custom Label" && customLabel === ""){
      alert("Please enter a valid Tag");
      return;
    }
    label = tagToUse === "Custom Label" ? customLabel : tagToUse;

    try {
      setIsUpdateTagWip(true);
      await (async function () {
        await ApiService.addTabOrLabelToBooking(event?.event?.bookingId, {label});
      })();
      event.event.tagOrLabel = label;
      handleSnackOpen(`Tag ${selectedTag} saved successfully...`, "success");
    } catch (error){
      handleSnackOpen("Error saving Tag...", "error");
    } finally {
      setCustomLabel("");
      dropdownRef.current.click();
      setIsUpdateTagWip(false);
    }
  };

  const handleBookingStatusUpdate = async (reason) => {
    try {
      await ApiService.updateBookingStatus(event.id,
          {reasonOrComments: reason, bookingStatus: selectedStatus});
      handleSnackOpen(`Status ${selectedStatus} saved successfully...`, "success");
    } catch (error) {
      handleSnackOpen("Error saving status...", "error");
    } finally {
      dropdownRef.current.click();
    }
  };

  return (
    <>
      {isShowBookingStatusUpdateModal && <GenericConfirmationModal
      title={"Confirm booking status update"}
      message={"Are you sure you want to update the booking status?"}
      buttonText={"Confirm"}
      handleClose={() => setIsShowBookingStatusUpdateModal(false)}
      isShowReason={true}
      showModal={isShowBookingStatusUpdateModal}
      handleConfirm={handleBookingStatusUpdate}
      />}


      <div
      style={{
        width: '30vw',
        height: 'auto',
        padding: '25px',
        background: 'white',
        borderRadius: '0px',
        color: 'black',
        border: '1px solid lightgray',
        display: 'block',
        boxShadow: '0 4px 4px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: '18px' }} >
          <span>Appointment Details &nbsp;
            <span>
              <BsSquareFill color={getStatusBgColor(event?.event?.bookingStatus)}/> </span>
          </span>
        </div>
        <div style={{ fontSize: '24px', cursor: "pointer", color: "gray" }} onClick={onClose}>x</div>
      </div>
      <hr />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Time</div>
        <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>
          {event?.event?.start?.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
        </div>
      </div>
      <br />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Location: </div>
        <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>{event?.event?.careLocation ?? 'unknown'}</div>
      </div>
      <br />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Id & Service: </div>
        <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>{event?.event?.bookingId || 'NA'}, {event?.event?.productNames || 'NA'}</div>
      </div>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Patient Name, DOB: </div>
        <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>{event?.event?.rawName || 'NA'}, {event?.event?.rawDob}</div>
      </div>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Preferred Pronouns: </div>
        <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>{event?.event?.pronoun || 'NA'}</div>
      </div>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Patient Contact:</div>
        <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>{event?.event?.rawEmail || 'NA'}, {event?.event?.rawPhone || 'NA'}</div>
      </div>
      <br />
      {/*<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>*/}
      {/*  <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Label & Status: </div>*/}
      {/*  <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}><BsTagsFill /> {event?.event?.tagOrLabel || 'NONE'},*/}
      {/*    <span><GrStatusGoodSmall color={statusColor}/> &nbsp; {event?.event?.bookingStatus}</span></div>*/}
      {/*</div>*/}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', opacity: 0.6, width: '100%' }}>Label & Status: </div>
        <div style={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '4px' }}><BsTagsFill /></span>
            <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {isUpdateTagWip === true && <Spinner animation="border" role="status" size="sm"></Spinner>}
                {event?.event?.tagOrLabel || 'NONE'}
            </span>
        </span>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '4px' }}><GrStatusGoodSmall color={getStatusBgColor(event?.event?.bookingStatus)} /></span>
            <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {event?.event?.bookingStatus}
            </span>
        </span>
        </div>
      </div>


      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

      <DropdownButton
      drop={"down"}
      className="new-dropdown"
      variant="light"
      id="dropdown-basic-button2"
      title={selectedTag || <><BsTagsFill /> Add Tag/Label</>}
      style={{ width: "200px" }}
      ref={dropdownRef}
      onClick={(e) => {
        e.stopPropagation();
      }}>
      <div>
        {/*<Dropdown.Header><span><BsTagsFill/></span>&nbsp; Add Tag/Label</Dropdown.Header>*/}


        {tagsArray.map((item, index) => (
          <Dropdown.Item
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              handleTagSelect(item);

              //custom label needs input and save button
              if(selectedTag === "Custom Label"){
                return;
              }
              //save tag right away
              (async function () {
                await saveTag(item);
              })();
            }}
            style={{ background: selectedTag === item ? "lightgray" : "transparent", }}
          >
            {item}
          </Dropdown.Item>
        ))}
        <hr />
        {selectedTag === "Custom Label" && (
              <Col>
                <Form.Control
                  type="text"
                  aria-label="Booking id"
                  aria-describedby="basic-addon1"
                  value={customLabel}
                  onChange={handleCustomLabelChange}
                  onClick={e => {
                    e.stopPropagation();
                  }}
                  onKeyDown={e => {
                    e.stopPropagation();
                  }}
                  placeholder="Enter Custom Label"
                />
              </Col>
            )}
            {selectedTag && (
              <Col style={{ width: "100%", display: "grid", placeItems: "center", marginTop: "10px" }}>
                <Button
                  variant="light"
                  style={{ width: "85%", color: "white", background: "#866BD9" }}
                  onClick={() => saveTag(selectedTag)}>
                  <span id="btn-text">Save</span>
                </Button>
              </Col>
            )}
      </div>
    </DropdownButton>


        {/*<DropdownButton*/}
        {/*  drop={"down"}*/}
        {/*  ref={dropdownRef2}*/}
        {/*  className="new-dropdown"*/}
        {/*  variant="light"*/}
        {/*  id="dropdown-basic-button2"*/}
        {/*  title={selectedStatus || "Update status"}*/}
        {/*  style={{ width: "200px" }}*/}
        {/*  onClick={e => {*/}
        {/*    e.stopPropagation();*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <div>*/}
        {/*    <Dropdown.Header>Update status</Dropdown.Header>*/}
        {/*    {statusArray.map((item, index) => (*/}
        {/*      <Dropdown.Item*/}
        {/*        key={index}*/}
        {/*        style={{ background: selectedStatus === item ? "lightgray" : "transparent", }}*/}
        {/*        onClick={e => {*/}
        {/*          e.stopPropagation();*/}
        {/*          setSelectedStatus(item);*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        {item}*/}
        {/*      </Dropdown.Item>*/}
        {/*    ))}*/}
        {/*    <hr />*/}
        {/*    {selectedStatus && (*/}
        {/*      <Col style={{ width: "100%", display: "grid", placeItems: "center", marginTop: "10px" }}>*/}
        {/*        <Button*/}
        {/*          variant="light"*/}
        {/*          style={{ width: "85%", color: "white", background: "#866BD9" }}*/}
        {/*          onClick={() => {*/}
        {/*            setSelectedStatus(selectedStatus);*/}
        {/*            setIsShowBookingStatusUpdateModal(true);*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          <span id="btn-text">Save</span>*/}
        {/*        </Button>*/}
        {/*      </Col>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*</DropdownButton>*/}
      </div>
      <hr />
      <br />
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center" }}>
        <div style={{ fontSize: '18px', cursor: "pointer", color: "#866BD9" }} onClick={handleSelectEvent}>Go to details <TbCircleArrowUpRightFilled /></div>
      </div>
        <div style={{ fontSize: '10px', opacity: 0.6, width: '100%' }}>TIP: Status can be updated from details page.</div>

      </div>
      <Snackbar open={snackOpen} autoHideDuration={4000} onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
    </>
  )
}

function Event(event) {
  const [showTooltip, setShowTooltip] = useState(false);
  const navigate = useHistory();
  const ref = useRef(null);

  const closeTooltip = () => {
    setShowTooltip(false);
  };

  const handleSelectEvent = () => {
    const bookingDetailUrl = `${process.env.REACT_APP_BASE_URL}/BookingDetails?bookingId=${event?.event?.bookingId}`;
    window.open(bookingDetailUrl, "_blank");
  };

  const getTarget = () => {
    return ReactDOM.findDOMNode(ref.current);
  };

  return (
    <div ref={ref} style={{
      //color: 'black',
      display: 'block',
      backgroundColor: getStatusBgColor(event?.event?.bookingStatus)}} >

      <div
        onClick={() => setShowTooltip(true)} // Open the tooltip directly
        style={{
          //color: 'black',
          display: 'block',
          backgroundColor: getStatusBgColor(event?.event?.bookingStatus),
        }}
      >
        <div style={{ fontSize: '18px', opacity: 0.8 }}>{event?.event?.patientName?.split(':')?.[1] || event?.event?.patientName || 'NA'}</div>
        <div style={{ fontSize: '14px', opacity: 0.8 }}>{event?.event?.start?.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</div>
        <div style={{ fontSize: '14px', opacity: 0.6 }}>{event?.event?.productType || 'NA'}</div>
      </div>
      <Overlay rootClose target={getTarget} show={showTooltip} placement="top" onHide={closeTooltip}>
        <Tooltip id="test">
          <TooltipContent event={event} onClose={closeTooltip} handleSelectEvent={handleSelectEvent} />
        </Tooltip>
      </Overlay>
    </div>
  );
}

export default BookingCalendar
